import React, { useState } from "react";
import axios from "axios";
import { Dialog } from "primereact/dialog";
import { Col, Row } from 'react-bootstrap';
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import { useAuth } from "../context/AuthContext";
import config from "../config";
import { InputTextarea } from "primereact/inputtextarea";
import GifLoder from "../components/GifLoder";

const EditSalarySlip = ({ editslip, onclose }) => {
    const { accessToken } = useAuth();
    const [loading, setLoading] = useState(false);

    const [Msl_id, setMslId] = useState(editslip.slNo ?? "");
    const [employee_name, setEmployeeName] = useState(editslip.name ?? "");
    const [designation, setDesignation] = useState(editslip.designation ?? "");
    const [date_of_joining, setDateOfJoining] = useState(editslip.doj ?? "");
    const [year, setYear] = useState(editslip.year ?? "");
    const [month, setMonth] = useState(editslip.month ?? "");

    const [total_days, setTotalDays] = useState(editslip.totalWorkingDays ?? 0);
    const [paid_leave, setPaidLeave] = useState(editslip.paidLeaveMonth ?? 0);
    const [late_count, setLateCount] = useState(editslip.noOfLate ?? 0);
    const [late_days, setLateDays] = useState(editslip.lateDays ?? 0);

    const [days_off_full, setDaysOffFull] = useState(editslip.daysOffFull ?? 0);
    const [days_off_half, setDaysOffHalf] = useState(editslip.daysOffHalf ?? 0);
    const [Absent_days, setAbsentDays] = useState(editslip.absentDays ?? 0);

    const [Paid_leave_used, setPaidLeaveUsed] = useState(editslip.paidLeaveUsed ?? 0);
    const [no_of_net_off_day, setNoOfNetOffDay] = useState(editslip.netOffDay ?? 0);
    const [Adjustment_leave, setAdjustmentLeave] = useState(editslip.adjustmentLeave ?? 0);
    const [no_of_days_for_Salary, setNoOfDaysForSalary] = useState(editslip.salaryDays ?? 0);

    const [Extra_Working_days, setExtraWorkingDays] = useState(editslip.extraWorkingDays ?? 0);
    const [Gross_Salary, setGrossSalary] = useState(editslip.grossSalary ?? 0);
    const [Salary, setSalary] = useState(editslip.salary ?? 0);
    const [Arrear_Salary, setArrearSalary] = useState(editslip.arrearSalary ?? 0);
    const [Total_Salary, setTotalSalary] = useState(editslip.totalSalary ?? 0);
    const [Overtime, setOvertime] = useState(editslip.overtime ?? 0);
    const [Total_including_overtime, setTotalIncludingOvertime] =
        useState(editslip.salaryWithOT ?? 0);

    const [P_Tax, setPTax] = useState(editslip.ptax ?? 0);
    const [Deductions, setDeductions] = useState(editslip.deductions ?? 0);
    const [Salary_Payable, setSalaryPayable] = useState(editslip.salaryPayable ?? 0);
    const [Adjustment, setAdjustment] = useState(editslip.adjustmentPaid ?? 0);
    const [Net_Payable, setNetPayable] = useState(editslip.netPayable ?? 0);

    const [Remarks, setRemarks] = useState(editslip.remarks ?? "");
    const [status, setStatus] = useState(editslip.status);
    const [paymentstatus, setPaymentstatus] = useState(editslip.Payment_Status);


    const handleSubmit = async () => {
        try {
            setLoading(true);

            const res = await axios.put(
                `${config.apiBASEURL}/Salary_Generation_Routes/monthly-slip/${editslip.slNo}`,
                {
                    total_days,
                    paid_leave,
                    late_count,
                    late_days,
                    days_off_full,
                    days_off_half,
                    Absent_days,
                    Paid_leave_used,
                    no_of_net_off_day,
                    Adjustment_leave,
                    no_of_days_for_Salary,
                    Extra_Working_days,
                    Gross_Salary,
                    Salary,
                    Arrear_Salary,
                    Total_Salary,
                    Overtime,
                    Total_including_overtime,
                    P_Tax,
                    Deductions,
                    Salary_Payable,
                    Adjustment,
                    Net_Payable,
                    Remarks,
                },
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                }
            );
            if (res.status === 200) {
                onclose(); // close modal
            }
        } catch (err) {
            console.error("❌ Failed to update slip:", err);
            alert(err.response?.data?.message || "Update failed. Check console for details.");
        } finally {
            setLoading(false);
        }
    };


    if (loading) {
        return <div className="loderDiv">
            <GifLoder />
        </div>;
    }


    return (
        <>
            <Row className="mx-0 pt-4">
                <h6 className="mb-4 pb-3 border-bottom">Edit Salary Slip</h6>
                <Col md={12} lg={12} className="mb-4 d-flex gap-3">
                    <img src={editslip.profile_image} alt="profile-image" className="rounded-circle" style={{ width: '50px', height: '50px' }} />
                    <div>
                        <p className="mb-0">
                            <b>{employee_name}</b>
                        </p>
                        <p className="mb-0">
                            <small>Designation:</small> <b>{designation}</b>
                        </p>
                        <p className="mb-0">
                            <small>Date of Joining:</small> <b>{date_of_joining}</b>
                        </p>
                        <p className="mb-0">
                            <small>EARNINGS FOR THE MONTH :</small><b>{month},{year}</b>
                        </p>
                        <p className="mb-0">
                            <small>Status :</small><b>{status}</b>
                        </p>
                        <p className="mb-0">
                            <small>Payment Status :</small><b>{paymentstatus}</b>
                        </p>
                    </div>
                </Col>
                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Late Days</label>
                    <InputNumber
                        value={late_days}
                        onValueChange={(e) => setLateDays(e.value)}
                        className="w-100"
                    />
                </Col>
                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Days OFF (Full)</label>
                    <InputNumber
                        value={days_off_full}
                        onValueChange={(e) => setDaysOffFull(e.value)}
                        className="w-100"
                    />
                </Col>

                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Total Days</label>
                    <InputNumber
                        value={total_days}
                        onValueChange={(e) => setTotalDays(e.value)}
                        className="w-100"
                    />
                </Col>
                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Paid Leave</label>
                    <InputNumber
                        value={paid_leave}
                        onValueChange={(e) => setPaidLeave(e.value)}
                        className="w-100"
                    />
                </Col>
                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Late Count</label>
                    <InputNumber
                        value={late_count}
                        onValueChange={(e) => setLateCount(e.value)}
                        className="w-100"
                    />
                </Col>
                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Days OFF (Half)</label>
                    <InputNumber
                        value={days_off_half}
                        onValueChange={(e) => setDaysOffHalf(e.value)}
                        className="w-100"
                    />
                </Col>

                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Absent Days</label>
                    <InputNumber
                        value={Absent_days}
                        onValueChange={(e) => setAbsentDays(e.value)}
                        className="w-100"
                    />
                </Col>

                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Paid Leave Used</label>
                    <InputNumber
                        value={Paid_leave_used}
                        onValueChange={(e) => setPaidLeaveUsed(e.value)}
                        className="w-100"
                    />
                </Col>

                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Net Off Days</label>
                    <InputNumber
                        value={no_of_net_off_day}
                        onValueChange={(e) => setNoOfNetOffDay(e.value)}
                        className="w-100"
                    />
                </Col>

                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Adjustment Leave</label>
                    <InputNumber
                        value={Adjustment_leave}
                        onValueChange={(e) => setAdjustmentLeave(e.value)}
                        className="w-100"
                    />
                </Col>

                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Days for Salary</label>
                    <InputNumber
                        value={no_of_days_for_Salary}
                        onValueChange={(e) => setNoOfDaysForSalary(e.value)}
                        className="w-100"
                    />
                </Col>

                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Extra Working Days</label>
                    <InputNumber
                        value={Extra_Working_days}
                        onValueChange={(e) => setExtraWorkingDays(e.value)}
                        className="w-100"
                    />
                </Col>

                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Gross Salary</label>
                    <InputNumber
                        value={Gross_Salary}
                        onValueChange={(e) => setGrossSalary(e.value)}
                        className="w-100"
                    />
                </Col>

                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Salary</label>
                    <InputNumber
                        value={Salary}
                        onValueChange={(e) => setSalary(e.value)}
                        className="w-100"
                    />
                </Col>

                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Arrear Salary</label>
                    <InputNumber
                        value={Arrear_Salary}
                        onValueChange={(e) => setArrearSalary(e.value)}
                        className="w-100"
                    />
                </Col>

                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Total Salary</label>
                    <InputNumber
                        value={Total_Salary}
                        onValueChange={(e) => setTotalSalary(e.value)}
                        className="w-100"
                    />
                </Col>

                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Overtime</label>
                    <InputNumber
                        value={Overtime}
                        onValueChange={(e) => setOvertime(e.value)}
                        className="w-100"
                    />
                </Col>

                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Total Including Overtime</label>
                    <InputNumber
                        value={Total_including_overtime}
                        onValueChange={(e) => setTotalIncludingOvertime(e.value)}
                        className="w-100"
                    />
                </Col>

                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">P Tax</label>
                    <InputNumber
                        value={P_Tax}
                        onValueChange={(e) => setPTax(e.value)}
                        className="w-100"
                    />
                </Col>

                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Deductions</label>
                    <InputNumber
                        value={Deductions}
                        onValueChange={(e) => setDeductions(e.value)}
                        className="w-100"
                    />
                </Col>

                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Salary Payable</label>
                    <InputNumber
                        value={Salary_Payable}
                        onValueChange={(e) => setSalaryPayable(e.value)}
                        className="w-100"
                    />
                </Col>

                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Adjustment</label>
                    <InputNumber
                        value={Adjustment}
                        onValueChange={(e) => setAdjustment(e.value)}
                        className="w-100"
                    />
                </Col>

                <Col md={6} lg={6} className="mb-3">
                    <label className="d-block">Net Payable</label>
                    <InputNumber
                        value={Net_Payable}
                        onValueChange={(e) => setNetPayable(e.value)}
                        className="w-100"
                    />
                </Col>
                <Col md={12} lg={12} className="mb-3">
                    <label className="d-block">Remarks</label>
                    <InputTextarea
                        value={Remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                        className="w-100 h-auto"
                        rows={4}       // number of visible rows
                        autoResize     // textarea will grow as user types
                    />
                </Col>
                <Col md={12} lg={12} className="mb-0 d-flex justify-content-end gap-2 mt-0">
                    <Button
                        label="Cancel"
                        icon="pi pi-times"
                        severity="secondary"
                        onClick={onclose}
                        className="py-2"
                    />

                    <Button
                        label="Save"
                        icon="pi pi-check"
                        severity="success"
                        onClick={handleSubmit}
                        loading={loading}
                        className="py-2"
                    />
                </Col>
            </Row>
        </>
    );
};

export default EditSalarySlip